import { FormControl, FormControlLabel, Stack } from '@mui/material'
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useEffect, useState } from 'react'
import { TextField, Checkbox } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import FormPageHeader from '../utilities/FormPageHeader';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import OAuthService from 'src/app/auth/services/oAuthService';
import { checkString } from '../utilities/FormValidation';


const OrderCategoryForm = () => {
    const [tabValue, setTabValue] = useState(0);
    const { id } = useParams()
    const [error, setError] = useState(false)
    const [validError, setValidError] = useState({});
    const [checksubmit, setCheckSubmit] = useState(false);
    const [displayName, setDisplayName] = useState();
    const [name, setName] = useState();
    const [allowOrder, setAllowOrder] = useState(true);
    const navigate = useNavigate()
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [editData, setEditData] = useState();
    const [hideDelete, setHideDelete] = useState(true)
    const [saveDisable, setSaveDisable] = useState(true)

    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderCategories}`;

    const handleSubmit = async () => {
        setCheckSubmit(true);
        let model = {
            name: name,
            displayName: displayName,
            allowOrder: allowOrder,
        };

        try {
            if (id) {
                if (name && displayName && !validError.name && !validError.displayName) {
                    await OAuthService.updateData(url, id, model);
                    setSuccessMsg("Data Updated Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/orderCategory'); }, 800)
                }
            } else {
                if (name && displayName && !validError.name && !validError.displayName) {
                    await OAuthService.addData(url, model);
                    setSuccessMsg("Data saved Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/orderCategory'); }, 800)
                }
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
            return;
        }

    }

    const GetOrderCategory = async () => {
        try {
            if (id) {
                const result = await OAuthService.getEditData(url, id);
                const name = result?.data?.name;
                const orderCategoryDisplayName = result?.data?.displayName;
                const allowOrder = result.data.allowOrder;
                setName(name);
                setDisplayName(orderCategoryDisplayName);
                setAllowOrder(allowOrder);
                setEditData(result?.data)
            }
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        if (id) {
            GetOrderCategory();
            setHideDelete(false)
        }
    }, [id])

    const handleDelete = async () => {

        try {
            if (id) {
                await OAuthService.deleteData(url, id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                setTimeout(() => { navigate('/orderCategory') }, 800);
            }

        } catch (error) {
            console.log("error", error);
            setError(error?.response?.data?.errorMessage || error.message);
        }
    }

    const handleCheckOrder = (value) => {
        setAllowOrder(value);
    }

    const handleCancel = () => {
        navigate('/orderCategory')
    }

    useEffect(() => {
        if (name && displayName) {
            if (editData) {
                if (editData?.name !== name || editData?.displayName !== displayName || editData?.allowOrder !== allowOrder) {
                    setSaveDisable(false);
                } else {
                    setSaveDisable(true);
                }
            } else {
                setSaveDisable(false);
            }
        } else {
            setSaveDisable(true);
        }
    }, [name, displayName, allowOrder]);

    return (
        <div className='w-full overflow-scroll'>

            <FormPageHeader
                componentName="Order Category"
                handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                breadCrumbSeperator=">"
                currentPage={id ? "Update Order Category" : "Add Order Category"}
                parentBreadcrumbData={[{ pageName: 'Order Category', pageLink: '/orderCategory' }]}
                error={error}
                successMsg={successMsg}
                snackState={snackState}
                handleCancel={handleCancel}
                hideDelete={hideDelete}
                saveDisable={saveDisable}
            >

                <Tabs
                    value={tabValue}
                    indicatorColor="secondary"
                    textColor="inherit"
                    variant="scrollable"
                    scrollButtons="auto"
                    classes={{ root: 'w-full border-b-1' }}
                >
                    <Tab
                        label="Basic Info"
                        sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
                    />
                </Tabs>
            </FormPageHeader>
            <div className="p-16 sm:p-24 max-w-3xl">
                <FormControl
                    // ref={formRef}
                    className="flex flex-col justify-center"
                >
                    <div className="">
                        <Stack>
                            <label>*Name</label>
                            <TextField
                                className="mt-8 mb-16"
                                required
                                type="text"
                                variant="outlined"
                                name='name'
                                value={name}
                                error={(checksubmit && !name) || validError.name ? true : false}
                                helperText={(checksubmit && !name) ? "This field is required" : validError.name}
                                onChange={(e) => { setName(e.target.value.toUpperCase()); setValidError({ ...validError, name: checkString(e.target.value) }) }}
                                InputLabelProps={{
                                    shrink: name ? true : false,
                                }}
                                disabled={id ? true : false}
                                inputProps={{ maxLength: 10 }}
                                sx={id ? { 
                                  backgroundColor: 'action.disabledBackground',
                                  "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: (theme) => theme.palette.text.primary,
                                  }
                                } : {}}
                            />
                        </Stack>
                        <Stack>
                            <label>*Display Name</label>
                            <TextField
                                className="mt-8 mb-16"
                                required
                                type="text"
                                variant="outlined"
                                name='displayName'
                                value={displayName}
                                error={(checksubmit && !displayName) || validError.displayName ? true : false}
                                helperText={(checksubmit && !displayName) ? "This field is required" : validError.displayName}
                                onChange={(e) => { setDisplayName(e.target.value.toUpperCase()); setValidError({ ...validError, displayName: checkString(e.target.value) }) }}
                                InputLabelProps={{
                                    shrink: displayName ? true : false,
                                }}
                            />
                        </Stack>
                        <Stack>
                            <FormControlLabel
                                checked={allowOrder}
                                onChange={(e) => handleCheckOrder(e.target.checked)}
                                control={<Checkbox defaultChecked />}
                                label="Allow category in create new order"
                            />
                        </Stack>
                    </div>

                </FormControl>
            </div>


        </div >
    )
}

export default OrderCategoryForm